import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { Button } from "catalyst/button";
import { Link } from "catalyst/link";
import { useState } from "react";
import { useProfile } from "../lib/api.js";
function RecoveryReminder({ profile }) {
    const storageKey = `hub:account-recovery-banner-dismissed:${profile.user_id}`;
    const [dismissed, setDismissed] = useState(() => {
        try {
            return localStorage.getItem(storageKey) === "true";
        }
        catch {
            return false;
        }
    });
    if (dismissed || profile.has_passkey || profile.verified_email) {
        return null;
    }
    const dismiss = () => {
        setDismissed(true);
        try {
            localStorage.setItem(storageKey, "true");
        }
        catch {
            // Keep the banner dismissed for this session if storage is unavailable.
        }
    };
    return (_jsxs("aside", { "aria-label": "\u0417\u0430\u0449\u0438\u0442\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0443", className: "mb-6 flex items-center gap-3 rounded-lg border border-amber-200 bg-amber-50 px-3 py-1 text-amber-950 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-100", children: [_jsxs("p", { className: "min-w-0 flex-1 text-sm/6", children: ["\u0427\u0442\u043E\u0431\u044B \u043D\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0443,", " ", _jsx(Link, { href: "/account?focus=email", className: "underline underline-offset-2", children: "\u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 email \u0438\u043B\u0438 passkey" })] }), _jsx(Button, { plain: true, className: "shrink-0", "aria-label": "\u0411\u043E\u043B\u044C\u0448\u0435 \u043D\u0435 \u043F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u043D\u0430\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u0435", onClick: dismiss, children: _jsx(XMarkIcon, {}) })] }));
}
export function AccountRecoveryBanner() {
    const { data: profile, error } = useProfile();
    if (!profile || error)
        return null;
    return _jsx(RecoveryReminder, { profile: profile }, profile.user_id);
}
